// extracted by mini-css-extract-plugin
export var dividerLine = "_6f-3";
export var itemImage = "_6f-9";
export var lightDivider = "_6f-4";
export var modalContent = "_6f-5";
export var modalContentCompact = "_6f-6";
export var productCard = "_6f-a";
export var productImage = "_6f-b";
export var productImageCompact = "_6f-7";
export var productImagePlaceholder = "_6f-c";
export var productImagePlaceholderCompact = "_6f-8";
export var progressBarBackground = "_6f-1";
export var progressBarContainer = "_6f-0";
export var progressBarFill = "_6f-2";